<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
}
</script>

<style lang="scss">
// 引入自定义全局scss
@import "./style/common.scss";
#app {
  width: 100vw;
  height: 100vh;
  overflow: hiddden;
  background: #f2f3f5;
}
</style>
